import { render, staticRenderFns } from "./StockInventoryRegradingRecordsInField.vue?vue&type=template&id=08568cb3&"
import script from "./StockInventoryRegradingRecordsInField.vue?vue&type=script&lang=js&"
export * from "./StockInventoryRegradingRecordsInField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField} from 'quasar'
component.options.components = Object.assign({QField}, component.options.components || {})
